import {
  getNonBetaTableProvidersOutputFields as getAllOutputFields,
  getTableProviderOutputFields as getOutputFields
} from "@utils/aegean_api_handler";

export const GET_OUTPUT_FIELDS_REQUEST = "GET_OUTPUT_FIELDS_REQUEST";
export const GET_OUTPUT_FIELDS_SUCCESS = "GET_OUTPUT_FIELDS_SUCCESS";
export const GET_OUTPUT_FIELDS_ERROR = "GET_OUTPUT_FIELDS_ERROR";
export const GET_PROVIDER_OUTPUT_FIELDS_REQUEST = "GET_PROVIDER_OUTPUT_FIELDS_REQUEST";
export const GET_PROVIDER_OUTPUT_FIELDS_SUCCESS = "GET_PROVIDER_OUTPUT_FIELDS_SUCCESS";
export const GET_PROVIDER_OUTPUT_FIELDS_ERROR = "GET_PROVIDER_OUTPUT_FIELDS_ERROR";

export const fetchOutputFields = () => (dispatch, getState) => {
  const store = getState();

  if (store.output_fields.isFetching || store.output_fields.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({
    type: GET_OUTPUT_FIELDS_REQUEST
  });

  return getAllOutputFields()
    .then((result) => {
      dispatch({
        type: GET_OUTPUT_FIELDS_SUCCESS,
        data: result
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_OUTPUT_FIELDS_ERROR,
        error
      });
    });
};

export const fetchProviderOutputFields = table_provider_id => (dispatch, getState) => {
  const store = getState();

  if (store.output_fields.data) {
    // If data is already fetched using fetchOutputFields action, we don't need to request it again
    const foundResult = store.output_fields.data.find(dataPiece => dataPiece.table_provider_id === table_provider_id);

    if (foundResult) {
      return Promise.resolve(foundResult.output_fields);
    }
  }

  dispatch({
    type: GET_PROVIDER_OUTPUT_FIELDS_REQUEST
  });

  return getOutputFields(table_provider_id)
    .then((output_fields) => {
      dispatch({
        type: GET_PROVIDER_OUTPUT_FIELDS_SUCCESS,
        output_fields,
        table_provider_id
      });
      return output_fields;
    })
    .catch((error) => {
      dispatch({
        type: GET_PROVIDER_OUTPUT_FIELDS_ERROR,
        error
      });
    });
};
